"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var CultureSelection_1 = require("./CultureSelection");
var DateFormatSelection_1 = require("./DateFormatSelection");
var TimeFormatSelection_1 = require("./TimeFormatSelection");
var TimeZoneSelection_1 = require("./TimeZoneSelection");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var RegionalFull = /** @class */ (function (_super) {
    tslib_1.__extends(RegionalFull, _super);
    function RegionalFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegionalFull.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(CultureSelection_1.default, null),
            React.createElement(DateFormatSelection_1.default, null),
            React.createElement(TimeFormatSelection_1.default, null),
            React.createElement(TimeZoneSelection_1.default, null)));
    };
    RegionalFull = tslib_1.__decorate([
        mobx_react_1.observer
    ], RegionalFull);
    return RegionalFull;
}(React.Component));
exports.default = RegionalFull;
//# sourceMappingURL=RegionalFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/view/RegionalFull.js
// module id = 4926
// module chunks = 2